// @flow
/** @jsx jsx */

import { css, jsx } from '@emotion/core';
import { LabeledRadio } from '@zapier/design-system';

const Styles = {
  root: css`
    display: flex;
  `,
};

type Props = {
  field?: {
    key: string,
    label: string,
    value: string,
    choices: Array<{ value: string, label: string }>,
    readOnly?: boolean,
  },
  value?: string,
  choices: Array<{ value: string, label: string }>,
  onChange: (value: string, props: {}) => void,
  readOnly?: boolean,
};

const RadioArray = (props: Props) => {
  const source = props.field || props;
  const isSelected = choice => choice.value === source.value;

  return (
    <div css={Styles.root}>
      {source.choices.map((choice, i) => (
        <LabeledRadio
          checked={isSelected(choice)}
          disabled={source.readOnly}
          key={choice.value + i}
          name="type"
          onChange={() => {
            props.onChange(choice.value, { field: source });
          }}
          value={choice.value}
        >
          {choice.label}
        </LabeledRadio>
      ))}
    </div>
  );
};

RadioArray.defaultProps = {
  choices: [],
};

export default RadioArray;
